// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__xoaTP","title":"InfoRow_title__3MaOs"};